import type { FunctionComponent, ReactNode } from 'react';

/** The model's reason behind a rating, set apart in a quiet box above the details it explains. */
export const AutomationRationale: FunctionComponent<{ readonly children: ReactNode }> = ({ children }) => (
    <p className="m-0 rounded-xl bg-surface-subtle px-l py-m text-body-xs leading-normal text-text-secondary">
        {children}
    </p>
);
